import styled from "styled-components";
import { breakpoints, zIndex } from "styles";

export const TanyaVideoPlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.65%;
  /* To avoid bug on mobile when user close fullscreen using back button on android */
  min-height: 200px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.brand["500"]};

  @media ${breakpoints.tablet} {
    min-height: 420px;
  }
`;

export const TanyaVideoIconButtonStyle = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.white};

  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  opacity: 0.9;

  &:hover,
  &:focus {
    outline: none;
    opacity: 1;
  }
`;

export const TanyaVideoPlayButton = styled(TanyaVideoIconButtonStyle)`
  margin: 0 60px;

  & svg {
    height: 60px;
    width: 60px;
    color: ${({ theme }) => theme.colors.brand[500]};

    @media ${breakpoints.tablet} {
      height: auto;
      width: auto;
    }
  }
`;

export const TanyaVideoPlayButtonPlaceholder = styled(TanyaVideoPlayButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${zIndex.videoPlayerControls};
  margin: 0;
`;
